import type { InputFilterMenu as InputFilterMenuType } from '@/components/FilterMenu'
import { useTranslation } from 'react-i18next'

interface OrganizationFilterProps {
  selectedValue: string | null
  onSearch: (value: string) => void
  InputFilterMenu: typeof InputFilterMenuType
}

function orgIdValidator(value: string): boolean {
  const maxLength = 6
  const pattern = /^[a-z0-9]{0,6}$/

  // ignore if value is too long or doesn't match the pattern
  return value.length <= maxLength && pattern.test(value)
}

export function OrganizationFilter({
  selectedValue,
  onSearch,
  InputFilterMenu,
}: OrganizationFilterProps) {
  const { t } = useTranslation()

  return (
    <InputFilterMenu
      buttonLabel={t('clusterConfigTable.filters.organization')}
      headerTitle={
        t('components.inputFilterMenu.filterBy', {
          label: t('clusterConfigTable.filters.organization'),
        }) as string
      }
      placeholder={
        t('components.inputFilterMenu.typePlaceholder', {
          label: t('clusterConfigTable.filters.organization'),
        }) as string
      }
      hint={
        t('components.inputFilterMenu.enterHint', {
          label: t('clusterConfigTable.filters.organization'),
        }) as string
      }
      onChangeValueValidator={orgIdValidator}
      onSearch={onSearch}
      selectedValue={selectedValue}
      data-testid="organization-id-filter"
    />
  )
}
